import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as AppContext from '../constants/AppContext';
import { getAppContext } from '../selectors/app';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncFeedbackLoader = Loadable({
  loader: () =>
  // @ts-expect-error untyped module
  import( /* webpackChunkName: 'feedback-loader' */'feedback-loader')
});
const FEEDBACK_SURVEY_TYPE = 'CSAT';
const FEEDBACK_SURVEY_ID = 853;
export default function FeedbackSurveyLoader() {
  const appContext = useSelector(getAppContext);
  const feedbackDisabled = useMemo(() => {
    return window.disabledHsPopups && window.disabledHsPopups.includes('FEEDBACK');
  }, []);
  useEffect(() => {
    if (appContext === AppContext.PUBLIC && window.hsFeedback && !feedbackDisabled) {
      window.hsFeedback.loadSurvey(FEEDBACK_SURVEY_TYPE, FEEDBACK_SURVEY_ID);
    }
  }, [appContext, feedbackDisabled]);
  if (appContext === AppContext.IN_APP && !feedbackDisabled) {
    return /*#__PURE__*/_jsx(AsyncFeedbackLoader, {
      onClientLoad: feedbackClient => feedbackClient.loadSurvey(FEEDBACK_SURVEY_TYPE, FEEDBACK_SURVEY_ID)
    });
  }
  return null;
}